import { Button, Image } from "antd";
import React, { useRef } from "react";
import { KEY, MODE_SCREEN } from "../../constants/common.const";
import { MSG_CATCH, showMessage } from "../../constants/utils";

import {
    CloseCircleFilled,
    PlusOutlined
} from "@ant-design/icons";
import API from "../../api/backend/machineManagement";

const FacilityImage = ({
  mode = MODE_SCREEN.VIEW,
  imageUrl,
  setImage,
  setIsDirty = () => {},
}) => {
  const avatarElRef = useRef(null);

  const uploadFile = async (file, type) => {
    const formData = new FormData();
    const body = {
      attachFileName: file.name,
      type: type,
    };
    formData.append("data", JSON.stringify(body));
    formData.append("file", file);

    try {
      const res = await API.uploadFile(formData);
      if (type == 3) {
        setImage(res.data.attachFileUrl);
      }
      return res.data;
    } catch (err) {
      showMessage(
        KEY.ERROR,
        (err.response && err.response.data.msg) || MSG_CATCH()
      );
    }
  };
  const handleChangeMachineImage = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    uploadFile(file, 3);
    setIsDirty(true);
    avatarElRef.current.value = null;
  };
  const deleteAvatar = () => {
    setImage(null);
  };

  if (mode === MODE_SCREEN.VIEW) {
    return (
      <div>
        <Image
          height={185}
          width={"100%"}
          src={imageUrl || "/img/default.png"}
        />
      </div>
    );
  }

  return (
    <div>
      <input
        type="file"
        className="d-none"
        ref={avatarElRef}
        accept="image/*"
        onChange={handleChangeMachineImage}
      />
      {!imageUrl && (
        <div
          style={{
            paddingInline: 5,
          }}
        >
          <Button
            // hidden={roles === "CUSTOMER" || roles === "SPECIAL_CUSTOMER"}
            onClick={() => {
              avatarElRef.current.click();
            }}
            style={{ width: "100%", height: "200px" }}
          >
            <b>
              <PlusOutlined /> 機器写真
            </b>
          </Button>
        </div>
      )}
      {imageUrl && (
        <>
          <div
            style={{
              position: "relative",
              marginTop: 20,
              paddingInline: 5,
            }}
          >
            <Image
              style={{ cursor: "pointer" }}
              onClick={() => avatarElRef.current.click()}
              preview={false}
              width={"100%"}
              height={185}
              src={imageUrl}
            />

            <CloseCircleFilled
              onClick={deleteAvatar}
              style={{
                position: "absolute",
                top: "-23px",
                right: "0px",
                fontSize: 23,
                cursor: "pointer",
                color: "gray",
              }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default FacilityImage;
